import React from 'react';
import { ConfigProvider } from 'antd';

import AppLoading from '@modules/main/AppLoading';
import AppRoutes from '@routes/routes';
import { Loading } from '@itz/react-cms-element';

// Bản cũ chạy antd 4 nên mọi thành phần VUÔNG GÓC; antd 5 mặc định borderRadius = 6px.
// Đưa toàn bộ token bo góc về 0 để khớp bản cũ (lớp CSS bù ở assets/scss/common.scss lo
// những chỗ antd 5 không đọc token, ví dụ popup dùng selector ghép).
const theme = {
    token: {
        borderRadius: 0,
        borderRadiusLG: 0,
        borderRadiusSM: 0,
        borderRadiusXS: 0,
        colorText: 'rgba(0, 0, 0, 0.65)',
        colorTextHeading: 'rgba(0, 0, 0, 0.85)',
    },
};

const App = () => (
    <ConfigProvider theme={theme}>
        <React.Suspense fallback={<Loading show />}>
            <AppLoading />
            <AppRoutes />
        </React.Suspense>
    </ConfigProvider>
);

export default App;
